import React, { useState } from "react";

const FolderTree = ({ root, selected, onSelect, mode = "files" }) => {
    const [expanded, setExpanded] = useState(false);

    if (!root) return null;

    const isFolder = root.isFolder;
    const isSelected = selected?.path === root.path;

    const handleClick = () => {
        if (isFolder) {
            setExpanded(!expanded);

            if (mode === "folders") {
                onSelect({ path: root.path, name: root.name });
            }
        } else {
            if (mode === "files") {
                onSelect({ path: root.path, name: root.name });
            }
        }
    };

    let children = root.children || [];

    if (mode === "folders") {
        children = children.filter((c) => c.isFolder);
    } else {
        children = [...children].sort((a, b) => {
            if (a.isFolder === b.isFolder) return a.name.localeCompare(b.name);
            return a.isFolder ? -1 : 1;
        });
    }

    return (
        <div className="folder-tree">
            <div
                className={`folder-item ${isSelected ? "selected" : ""}`}
                onClick={handleClick}
            >
                {isFolder ? (
                    <i
                        className={`fa-solid ${
                            expanded ? "fa-folder-open" : "fa-folder"
                        } folder-icon`}
                    ></i>
                ) : (
                    <i className="fa-regular fa-file-audio file-icon"></i>
                )}
                <span className="folder-name" title={root.name}>{root.name}</span>
            </div>

            {expanded && children.length > 0 && (
                <div className="folder-children" style={{ paddingLeft: 16 }}>
                    {children.map((child) => (
                        <FolderTree
                            key={child.path}
                            root={child}
                            selected={selected}
                            onSelect={onSelect}
                            mode={mode}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

export default FolderTree;
